import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  FooterContainer,
  InfoText,
  Extra,
  LogoContainer,
  Title,
  NavLink,
  Para,
  Large,
  Chat,
  Empty,
  Language,
  Label,
  LanguageSwitch,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
<>
      <FooterSection>
        <Container>
          <FooterContainer style={{ textAlign: 'center', padding: '20px 0',  }}>
            <InfoText>
              대표이사 : 박경빈 | 이메일 : gbpark@uf5.io<br />
              전화번호 : 0507-1334-3546 <br />
              사업자등록번호: 376-87-03088<br />
              통신판매신고번호 : 제2024-서울강남-03158호<br />
              서울특별시 강남구 남부순환로 359길 14, 3층<br />
              Copyright © 2025 UF5. All Rights Reserved.
            </InfoText>
          </FooterContainer>
        </Container>
      </FooterSection>
      
      <Extra>
        <Container border={true}>
        <Row
      justify="center" // 중앙 정렬로 변경
      align="middle"
      style={{ paddingTop: "3rem" }}
    >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logoData101.png"
                  aria-label="homepage"
                  width="130px"
                  height="27px"
                />
              </LogoContainer>
            </NavLink>
            {/* <FooterContainer>
              <SocialLink
                href="https://github.com/Adrinlol/create-react-app-adrinlol"
                src="github.svg"
              />
              <SocialLink
                href="https://twitter.com/Adrinlolx"
                src="twitter.svg"
              />
              <SocialLink
                href="https://www.linkedin.com/in/lasha-kakabadze/"
                src="linkedin.svg"
              />
              <SocialLink
                href="https://medium.com/@lashakakabadze/"
                src="medium.svg"
              />
              <a
                href="https://ko-fi.com/Y8Y7H8BNJ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  height="36"
                  style={{ border: 0, height: 36 }}
                  src="https://storage.ko-fi.com/cdn/kofi3.png?v=3"
                  alt="DATA101 BLOG"
                />
              </a>
            </FooterContainer> */}
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
